// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BalloonIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 2A11.013 11.013 0 0 0 5 13c0 2.929 1.175 6.177 3.141 8.688 1.51 1.926 3.313 3.25 5.239 3.886l-1.299 3.032A1 1 0 0 0 13 30h6a1 1 0 0 0 .919-1.394l-1.294-3.032c1.925-.634 3.729-1.96 5.239-3.887C25.825 19.178 27 15.93 27 13A11.012 11.012 0 0 0 16 2Zm1.484 26h-2.968l.868-2.024c.205.015.41.024.616.024.206 0 .411-.009.616-.024L17.484 28Zm4.8-7.546C20.493 22.74 18.26 24 16 24s-4.492-1.259-6.284-3.546C8.015 18.284 7 15.5 7 13a9 9 0 0 1 18 0c0 2.5-1.015 5.284-2.716 7.454Zm-.125-7.468a1 1 0 0 1-1.144-.821 5.162 5.162 0 0 0-4.179-4.179 1 1 0 1 1 .33-1.972 7.188 7.188 0 0 1 5.822 5.821 1.001 1.001 0 0 1-.823 1.151h-.006Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
